module.exports = __webpack_public_path__ + "icon-144x144.png";